var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 18.7501C16.913 18.7501 17.5489 18.4868 18.0178 18.0179C18.4866 17.5491 18.75 16.9132 18.75 16.2501V9.43848L13.0175 12.7901L15.9217 14.3535C16.0676 14.4322 16.1764 14.5656 16.224 14.7245C16.2716 14.8833 16.2541 15.0546 16.1754 15.2006C16.0967 15.3465 15.9633 15.4553 15.8044 15.5029C15.6456 15.5505 15.4743 15.533 15.3283 15.4543L10.5925 12.9043C10.4104 12.8063 10.2068 12.755 10 12.755C9.79319 12.755 9.5896 12.8063 9.4075 12.9043L4.67167 15.4543C4.5261 15.5296 4.35675 15.5448 4.20013 15.4965C4.0435 15.4481 3.91213 15.3402 3.83431 15.196C3.7565 15.0517 3.73847 14.8826 3.78411 14.7252C3.82976 14.5678 3.93542 14.4346 4.07833 14.3543L6.9825 12.7901L1.25 9.43848V16.2501C1.25 16.9132 1.51339 17.5491 1.98223 18.0179C2.45107 18.4868 3.08696 18.7501 3.75 18.7501H16.25Z",
    fill: "url(#paint0_linear_136_4131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.99107V7.37024C1.24994 6.91871 1.37216 6.47559 1.60369 6.08795C1.83522 5.7003 2.16742 5.3826 2.565 5.16857L8.815 1.80357C9.17921 1.60751 9.58637 1.50488 10 1.50488C10.4136 1.50488 10.8208 1.60751 11.185 1.80357L17.435 5.16857C17.8326 5.3826 18.1648 5.7003 18.3963 6.08795C18.6278 6.47559 18.7501 6.91871 18.75 7.37024V7.99107L11.7283 12.0961L11.185 11.8036C10.8208 11.6075 10.4136 11.5049 10 11.5049C9.58637 11.5049 9.17921 11.6075 8.815 11.8036L8.27167 12.0961L1.25 7.99107Z",
    fill: "url(#paint1_linear_136_4131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_4131",
    x1: 10,
    y1: 4.93283,
    x2: 10,
    y2: 18.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_136_4131",
    x1: 10,
    y1: -3.61989,
    x2: 10,
    y2: 12.0961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78520"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2a3b7721a1ec6a01e5b0ab72d928e2a0.svg";
export { ForwardRef as ReactComponent };